import { createSlice } from "@reduxjs/toolkit";
import { loginUser, forgotPassword } from "../thunks/loginThunk";

const initialState = {
  isLoading: false,
  loginErr: null,
  forgotUserId: null,
  forgotEmail: null,
  forgototptype: null,
  userAccessToken: null,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    resetForgotPassword: (state) => {
      state.forgotUserId = null;
      state.forgotEmail = null;
      state.forgototptype = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.loginErr = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userAccessToken = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.loginErr = action.payload;
      })
      .addCase(forgotPassword.pending, (state) => {
        state.isLoading = true;
        state.loginErr = null;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.forgotUserId = action.payload.data.userID;
        state.forgotEmail = action.payload.data.email;
        state.forgototptype = action.payload.data.otpType;
        // console.log(
        //   "The data is :",
        //   state.forgotEmail,
        //   state.forgotUserId,
        //   state.forgototptype
        // );
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.isLoading = false;
        state.loginErr = action.payload;
      });
  },
});

export const { resetForgotPassword } = loginSlice.actions;
export default loginSlice.reducer;
